export const BRAND_NAME = 'KheloyaarCasino';
// Note: It is the main site url. Ex - mazaa.io, etc.
export const BRAND_DOMAIN = 'kheloyaarcasino.com';
// Note: It is the main site url. Ex - mazaa.io, etc.
export const BRAND_DOMAIN_SKIN_URL = 'kheloyaarcasino.com';                     
export const PROVIDER = 'BetFair';
export const PROVIDER_ID = 'BetFair';
export const BACKEND_DOMAIN = 'cue88.com';